import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from 'src/app/_service/message-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-delete-mobile',
  templateUrl: './delete-mobile.component.html',
  styleUrls: ['./delete-mobile.component.scss']
})

export class DeleteMobileComponent implements OnInit {
  
  @ViewChild('otpDialog') otpDialog: TemplateRef<any>;
  selectedInputType: string = 'email';
  userForm: FormGroup;
  otpForm: FormGroup;
  otp: string = '';
  phone;
  tenantId = '';
  keyValue ='';
  countryInitials ='IN';
  countryCode = '+91'
  constructor(private fb: FormBuilder , private dialog: MatDialog,private http: HttpClient,private route: ActivatedRoute,private toastr: SnackbarService) {}

  ngOnInit() {
    this.route.params.subscribe((params => {
      this.tenantId = params.tenantId
      if(this.tenantId == '5b821d06-e0e5-432b-8881-c410084daaca'){
        this.countryInitials = 'MY'
        this.countryCode = '+60'
      } else if(this.tenantId == '7e0daa72-bad5-45f3-bc5e-3176e39ddf34'){
        this.countryInitials= 'NP'
        this.countryCode = '+977'
      } else {
        this.countryInitials = 'IN'
        this.countryCode = '+91'
      }
    }))
    this.userForm = this.fb.group({
      name: [''],
      inputType: ['email'],
      email: ['', [Validators.required, Validators.email]],
      mobileNumber: ['', Validators.compose([Validators.required, this.numericValidator
      ])],
    });

    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
    });
  }
  submitForm() {
    this.userForm.value.inputType == 'email' ? this.keyValue = this.userForm.value.email: this.keyValue = this.userForm.value.mobileNumber
    let url = `${environment.API_BASE_PATH}/users/otp/login`
    //let url = 'https://dev-csms.telioev.com/api/users/login/otp'
    let headers = {
      headers: {
        'Accept-Version': 'V2', 'X-Device-ID': 'WEB', 'key': String(this.keyValue),'Content-Type' : 'application/json',
        'Accept-Language': 'en','X-Tenant-ID': String(this.tenantId), 'countryInitials': this.countryInitials, 'countryCode': this.countryCode
      }
    }
    this.http.get(url, headers).subscribe((resp: any) => {
      if(!!resp){
        this.openOtpDialog()
      }
      else {
        this.toastr.error(resp.status_message)
      }
    },error=>{
      console.error(error)
    })

  }

  openOtpDialog(): void {
    const dialogRef = this.dialog.open(this.otpDialog, {
      width: '300px', 
      height: '400px', 
      data: { otp: this.otp }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.otp = result;
        this.submitOTP(result)
      }
    });
  }

  isEmailOrMobileValid(): boolean {
    return (
      (this.userForm.get('inputType').value === 'email' && this.userForm.get('email').valid) ||
      (this.userForm.get('inputType').value === 'mobile' && this.userForm.get('mobileNumber').valid)
    );
  }

  numericValidator(control) {
    const numericPattern = /^[0-9]*$/;
    if (!numericPattern.test(control.value)) {
      return { notNumeric: true };
    }
    return null;
  }

  submitOTP(result){
    let url = `${environment.API_BASE_PATH}/users/delete-playstore`
    let headers = {
      headers: {
        'Accept-Version': 'V2', 'X-Device-ID': 'WEB', 'key': String(this.keyValue),'otp' : String(result),
        'Accept-Language': 'en','X-Tenant-ID': String(this.tenantId), 'countryInitials': this.countryInitials, 'countryCode': this.countryCode
      }
    }
    this.http.delete(url,headers).subscribe((resp:any)=>{
      if(!!resp){
      this.toastr.success('User deleted successfully')
      this.userForm.reset()
      } else{
        this.toastr.error('Invalid OTP')
      }
    },error=>{
      console.error(error)
    })
  }
}
